import { PageSection } from 'components';
import DOMPurify from 'dompurify';
import { useTranslation } from 'react-i18next';
import { CustomArrowProps, Settings } from 'react-slick';
import { UNIVERSITIES_EN, UNIVERSITIES_RU } from 'consts';

import { StyledSlider, UniCircle, UniCircleDiv, UniImage } from './styled';
import { Icon } from 'kl-b2c-ui-kit';
import { Title } from '../../styled';

const sectionConfig = {
    CWrap: {
        css: {
            paddingBottom: 70,
            '@media(max-width: 767px)': {
                paddingBottom: 50,
            },
        },
    },
    ContentArea: {
        css: {
            display: 'block',
            position: 'relative',
            zIndex: 10,
            '@media(max-width: 767px)': {
                paddingTop: '0 !important',
            },
        },
    },
};

const SlickArrowLeft = ({ ...props }: CustomArrowProps) => (
    <button
        {...props}
        className={'slick-prev slick-arrow'}
        aria-hidden={'true'}
        type={'button'}>
        <Icon name={'ArrowLeftThin'} color={'white'} size={25} />
    </button>
);

const SlickArrowRight = ({ ...props }: CustomArrowProps) => (
    <button
        {...props}
        className={'slick-next slick-arrow'}
        aria-hidden={'true'}
        type={'button'}>
        <Icon name={'ArrowRightThin'} color={'white'} size={25} />
    </button>
);

const CAROUSEL_SETTINGS: Settings = {
    slidesToScroll: 1,
    infinite: false,
    slidesToShow: 6,
    arrows: true,
    dots: false,
    prevArrow: <SlickArrowLeft />,
    nextArrow: <SlickArrowRight />,
    responsive: [
        {
            breakpoint: 1279,
            settings: {
                slidesToScroll: 2,
                slidesToShow: 4,
            },
        },
        {
            breakpoint: 1023,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                arrows: false,
            },
        },
    ],
};

export const Universities = () => {
    const { t } = useTranslation('pages/academy-alliance');

    const locale = process.env.REACT_APP_LOCALE;

    return (
        <PageSection config={sectionConfig}>
            <Title
                dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(t('uni-title')),
                }}
            />
            <StyledSlider {...CAROUSEL_SETTINGS}>
                {(locale === 'ru' ? UNIVERSITIES_RU : UNIVERSITIES_EN).map(
                    (item: string, index: number) =>
                        item ? (
                            <UniCircle
                                key={index}
                                href={item}
                                target={'_blank'}>
                                <UniImage
                                    imageUrl={`/assets/alliance/universities/${locale}/${
                                        index + 1
                                    }.png`}
                                />
                            </UniCircle>
                        ) : (
                            <UniCircleDiv key={index}>
                                <span>{t('and-more')}</span>
                            </UniCircleDiv>
                        )
                )}
            </StyledSlider>
        </PageSection>
    );
};
